import Paper from "@material-ui/core/Paper";
import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { fetchJSON } from "helpers/axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const SiwesLetter = () => {
  const location = useLocation();
  const url = location.search;
  const StudId = url !== "" ? url?.match(/StudId=(.*)/)[1] : "";
  if (StudId == "") {
    window.location.href = "/portal";
  }
  const [letterAdm, setLetterAdm] = useState(null);

  useMemo(async () => {
    try {
      const response = await fetchJSON(
        `api/SIWESLETTER?StudId=${StudId}`,
        null,
        "GET"
      );

      setLetterAdm(response.Data);
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  }, []);

  return (
    <>
      <Paper elevation={2}>
        <div
          id="content"
          className="container mt-3 pt-0"
          style={{ overflowY: "scroll !important" }}
        >
          {letterAdm && (
            <div className="">
              <header>
                <div className="text-center">
                  <h1
                    className="font-size-heading"
                    style={{
                      color: "#093368",
                      fontSize: "45px",
                      fontWeight: "600",
                      textAlign: "center",
                      fontFamily: "Roboto !important",
                      maxWidth: "100%",
                    }}
                  >
                    <strong>
                      Babalola Academy Collage of Health Technology, Ilorin
                    </strong>
                  </h1>
                </div>
              </header>

              <div
                className="d-flex justify-content-between"
                style={{ fontSize: "15px", paddingRight: "3rem" }}
              >
                <div>
                  <strong>Professor Augustine Oko Angba</strong>
                  <br />
                  <strong
                    className="text-muted"
                    style={{ fontSize: "15px", fontStyle: "italic" }}
                  >
                    VICE CHANCELLOR
                  </strong>
                </div>

                <div>
                  <img
                    className="img-fluid"
                    src="https://unicrossdoc.blob.core.windows.net/passport/UNICROSS%20Logo%20-%20whitebg.png?sp=r&st=2022-10-17T15:19:36Z&se=2122-10-17T23:19:36Z&spr=https&sv=2021-06-08&sr=b&sig=TlwLNipSBRc%2BhjvTbnacUYmgEvo1H7s41Jd5tHqYMkE%3D"
                    alt=""
                    style={{ maxWidth: "130px", maxHeight: "160px" }}
                  />
                </div>

                <div
                  className="text-left"
                  style={{ fontSize: "15px", fontStyle: "italic" }}
                >
                  <strong>Office of The Vice Chancellor</strong>
                  <br />
                  {/* <strong></strong>
                  <br /> */}
                  <strong>P.M.B. 1123</strong>
                  <br />
                  <strong>Ilorin</strong>
                  <br />
                  <strong>Kwara State</strong>
                  <br />
                  <strong>Nigeria</strong>
                </div>
              </div>
              <hr
                className="mr-5"
                style={{
                  border: "1.5px solid black",
                  textAlign: "justify",
                }}
              />
              <div
                style={{
                  fontSize: "22px",
                }}
              >
                <strong className="text-center">
                  <u>
                    SIWES UNITS: STUDENT'S PLACEMENT APPLICATION FOR{" "}
                    {/* {letterAdm?.Session}  */}2022 SIWES PROGRAMME
                  </u>
                </strong>
                <br />
                <div
                  style={{ fontSize: "22px" }}
                  className="d-flex justify-content-between mr-5"
                >
                  <h5>
                    Our Ref: UNICROSS/SIWES/APP/21/{letterAdm?.SIWESFormRef}
                  </h5>
                  <h5>2nd February, 2023</h5>
                </div>
                <strong>
                  <p>
                    ......................................................................................
                  </p>
                  <p>
                    ......................................................................................
                  </p>
                  <p>
                    ......................................................................................
                  </p>
                </strong>
              </div>
              <div
                className="text-center"
                style={{
                  fontSize: "20px",
                }}
              >
                <p>
                  <strong>
                    STUDENT’S INDUSTRIAL WORK EXPERIENCE SCHEME (SIWES):
                  </strong>

                  <br />

                  <strong>2022 PLACEMENT APPLICATION</strong>
                </p>
              </div>
              <div
                style={{
                  fontSize: "20px",
                }}
              >
                <u>
                  <strong>
                    RE: {letterAdm?.Name} {letterAdm?.MatricNumber}
                  </strong>
                </u>
              </div>
              <div
                className=""
                style={{
                  textAlign: "justify",
                  fontSize: "18px",
                  paddingRight: "3rem",
                }}
              >
                <p>
                  The Students’ Industrial Work Experience Scheme (SIWES) is an
                  academic programme designed to expose and prepare students in
                  their{" "}
                  {(letterAdm?.levelId === 2 ? "second" : "") ||
                    (letterAdm?.levelId === 3 ? "third" : "") ||
                    (letterAdm?.levelId === 4 ? "fourth" : "")}{" "}
                  year in various academic discipline for real industrial work
                  situation which they are likely to meet after their
                  graduation. It is a{" "}
                  {letterAdm?.CourseOfStudy === "Computer Science"
                    ? "3-month"
                    : "6-month"}{" "}
                  industrial training programme; and a requirement for the award
                  of Bachelor’s degree in specified disciplines. The 2022 SIWES
                  programme for students of Babalola Academy Collage of Health
                  Technology, Ilorin
                </p>
                <p>
                  We write to request your kind acceptance of our students on
                  the SIWES programme, to enable them acquire practical
                  experience under a designated supervisor in your
                  establishment. Supervisors from our institution and the
                  Industrial Training Fund (ITF) shall also visit the students
                  periodically within the duration of the programme.
                </p>
                <p>
                  We have students from 24 departments in the faculties of
                  Agriculture, Engineering, Education, Physical Sciences,
                  Environmental Sciences, Management Sciences, Architecture,
                  Biological Sciences, and Basic Medical Sciences.
                </p>
                <p>
                  <strong>
                    {letterAdm?.Name} is a{" "}
                    {letterAdm?.GraduatingLevel === 4 ? "third" : "fourth"} year
                    student of the Department of{" "}
                    {letterAdm?.CourseOfStudy.toUpperCase()} and is eligible to
                    participate in the programme. The Student could be reached
                    {/* on {authUser?.Email} or {authUser?.PhoneNumber}. */}
                  </strong>
                </p>
                <p>
                  We appreciate your cooperation in accepting and providing
                  relevant practical training to our students.
                </p>
                <p>Thank you and kindest regards.</p>
                <h5>Sincerely</h5>
              </div>

              <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center mb-5">
                <div className="col-md-4">
                  <strong className="mr-3">
                    <img
                      src="https://unicrossdoc.blob.core.windows.net/assignment/SiwesDirectorSignature.jpeg"
                      alt="SIWES Director"
                      style={{
                        height: "30%",
                        width: "50%",
                        objectFit: "contain",
                        // backgroundColor: "#fff",
                      }}
                    />
                  </strong>
                  <div>
                    <span>Assoc. Professor Adebisi Adesola</span>
                    <br />
                    <span>SIWES Director</span>
                    <br />
                    <span>adebisiadesola@unicross.edu.ng</span>
                    <br />
                    <span>+2348037025787</span>
                  </div>
                </div>
                <div className="text-center col-md-3 mt-3 mt-md-0">
                  <h5 className="text-muted mt-3" style={{ fontSize: "20px" }}>
                    Verify Document
                  </h5>
                  <div>
                    <img
                      className="img-fluid"
                      src={letterAdm?.QRcode}
                      alt=""
                      style={{
                        maxWidth: "110px",
                        maxHeight: "110px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-4 mt-3">
                  <strong style={{ textAlign: "center" }}>
                    <img
                      src="https://unicrossdoc.blob.core.windows.net/assignment/DeputyVCSignature.png"
                      alt="DVC"
                      style={{
                        height: "40%",
                        width: "70%",
                        objectFit: "contain",
                      }}
                    />
                  </strong>

                  <div className="px-auto">
                    <span>Prof. (Mrs)Joy M. Etiowo</span>
                    <br />
                    <span>Deputy Vice-Chancellor(Academic)</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Paper>
    </>
  );
};

export default SiwesLetter;
